<template>
  <div id="look">
    <ul>
      <li
        v-for="(item, i) in list"
        :key="item.id"
        :class="i === list.length - 1 ? '' : 'list'"
      >
        <p style="cursor: pointer" @click="goDetils(item)" v-html="item.title"></p>
      </li>
      <!--      <li class="list">-->
      <!--        <p>-->
      <!--          国家医保局国家卫生健康委关于建立完善国家医保谈判药品“双通道”管理机制的指导意见中文知识网用户指南-->
      <!--        </p>-->
      <!--      </li>-->
      <!--      <li class="list">-->
      <!--        <p>-->
      <!--          国家医保局国家卫生健康委关于建立完善国家医保谈判药品“双通道”管理机制的指导意见中文知识网用户指南-->
      <!--        </p>-->
      <!--      </li>-->
      <!--      <li class="list">-->
      <!--        <p>-->
      <!--          国家医保局国家卫生健康委关于建立完善国家医保谈判药品“双通道”管理机制的指导意见中文知识网用户指南-->
      <!--        </p>-->
      <!--      </li>-->
    </ul>
    <Paging
      :total="total"
      :curPage="page"
      :limit="10"
      :showPage="5"
      @changePager="handlePager"
    ></Paging>
  </div>
</template>

<script>
import Paging from "@/components/paging/index.vue";
export default {
  name: "look",
  components: {
    Paging,
  },
  data() {
    return {
      total: 0,
      page: 1,
      list: [],
    };
  },
  created() {
    this.browse();
  },
  methods: {
    goDetils(e) {
      console.log(e);
    },
    async browse() {
      let obj = {
        pageSize: 10,
        pageNo: this.page,
      };
      let res = await this.$apis.userServe.browseList(obj);
      this.total = res.content.page.total;
      this.list = res.content.page.list;
    },
    handlePager(i) {
      this.page = i;
      this.browse();
    },
  },
};
</script>

<style lang="scss" scoped>
#look {
  padding-top: 30px;
  padding-bottom: 20px;
  width: 1200px;
  //height: 1000px;
  min-height: 532px;
  background: #ffffff;
  margin-top: 20px;
  box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);
  ul {
    margin-left: 44px;
    margin-right: 51px;
    .list {
      border-bottom: 1px #a0a0a0 dotted;
    }
    li {
      width: 100%;
      height: 60px;
      //background: pink;
      p {
        width: 564px;
        height: 60px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 60px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
  }
}
</style>
